import { Settings2 } from "lucide-react";

type ListSettingsButtonProps = {
  onClick: () => void;
  disabled?: boolean;
  /** Compact mode — small icon-only button for ClickUp-style toolbar */
  compact?: boolean;
};

export function ListSettingsButton({ onClick, disabled = false, compact = false }: ListSettingsButtonProps) {
  if (compact) {
    return (
      <button
        type="button"
        onClick={onClick}
        disabled={disabled}
        className="flex items-center justify-center h-8 w-8 rounded-xs text-muted-foreground hover:text-foreground hover:bg-accent/60 transition-colors disabled:opacity-50 disabled:pointer-events-none"
        aria-label="Settings"
      >
        <Settings2 className="h-4 w-4" />
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="hidden h-14 px-5 text-base font-normal rounded-full bg-white dark:bg-gray-900 border border-border hover:scale-105 active:scale-95 transition-all duration-300 ease-out hover:bg-white/40 dark:hover:bg-gray-800/40 lg:flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
      aria-label="List Settings"
    >
      <Settings2 className="size-5 text-muted-foreground" />
      Settings
    </button>
  );
}
